import { useEffect } from 'react'
import { AxiosResponse } from 'axios'
import { useQueryClient } from 'react-query'
import { authQuery } from 'parts/requests/auth/authQuery'
import useSystemStore from 'parts/systemStore/systemStore'
import AuthApiTypes from 'parts/requests/auth/authApiTypes'
import { hasStoredAccessToken } from './getData'

/** Restores the session from /auth/refresh only when an access token exists. */
export function useSetUser() {
	const queryClient = useQueryClient()
	const user = useSystemStore((store) => store.user)
	const canRefresh = hasStoredAccessToken()

	useEffect(
		function () {
			if (!canRefresh) {
				useSystemStore.getState().updateStore({ user: null as any })
				return
			}
			if (user === undefined) {
				queryClient.refetchQueries({
					queryKey: [authQuery.refresh.key],
				})
			}
		},
		[user, canRefresh, queryClient]
	)

	authQuery.refresh.useQuery({
		enabled: canRefresh,
		onSuccess: querySuccess,
		onError: queryError,
	})
}

/**
 * Функция запускаемая при ошибке запроса данных. Срабатывает для любых запросов.
 * Ставит в Состояние статус загрузки «Ошибка» и сообщение об этом показывается в интерфейсе.
 * @param userRes
 */
function querySuccess(userRes: AxiosResponse<AuthApiTypes.Refresh>) {
	const updateSystemStore = useSystemStore.getState().updateStore
	updateSystemStore({ user: userRes.data.user })

	localStorage.setItem('user', JSON.stringify(userRes.data.user))
	localStorage.setItem('token', userRes.data.accessToken)
}

/**
 * Функция запускаемая при ошибке запроса данных. Срабатывает для любых запросов.
 * Ставит в Состояние статус загрузки «Ошибка» и сообщение об этом показывается в интерфейсе.
 * @param err — объект ошибки.
 */
function queryError(err: unknown) {
	// message.error('При получении данных пользователя произошла ошибка.')

	localStorage.removeItem('user')
	localStorage.removeItem('token')

	const updateSystemStore = useSystemStore.getState().updateStore
	updateSystemStore({ user: null as any })
}
